__turbopack_context__.v({
  "turn": "NfPIRW_turn",
  "word": "NfPIRW_word",
});
